export default __webpack_public_path__ + "static/media/img4.1da44c01.png";